// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1cj7t","assignButton":"CreateEditEquipmentSchedule_assignButton__20p3D"};